<div class="w-full flex justify-between items-center pl-1">
  <div class="justify-start text-surface-800 text-lg font-medium font-['Inter']">{{stepTitle()}}</div>
  <div class="flex gap-4">
    @if (canGoBack()) {
      <p-button data-testid="create-ta-back" (click)="goBack()"><i class="fa-regular fa-chevron-left"></i>{{'Back'}}</p-button>
    }
    <p-button data-testid="create-ta-save-continue" (click)="saveAndContinue()" [disabled]="!canContinue()">{{'Save and Continue'}}<i class="fa-regular fa-chevron-right"></i></p-button>
  </div>
</div>
